/*global angular*/
/*global _*/

import '../../../components/helpers/AppHelper';
import '../controllers/summary';
import '../controllers/clink_url_decoder';
import '../controllers/clink_id_decoder';
import '../filters';
import jQuery from 'jquery';
import { react2angular } from 'react2angular';
import TagsAutocompleteWrapper from '../../../../components/autocompletes/tags/TagsAutocompleteWrapper';
import TrafficSourcesAutocompleteWrapper from '../../../../components/autocompletes/trafficSources/TrafficSourcesAutocompleteWrapper';
import { canEditCLink, canEditClinkField } from '../../../../utils/UserHelper'

// undefined variables during migration - set to defaults to compile
let pubID = null;
let siteID = null;
let viewAs = null;
let allowAvailable = false;

angular.module('clinkManager')
.component('tagsAutocompleteWrapper',           react2angular(TagsAutocompleteWrapper,           ['setTagsStorage', 'tagsStorage']))
.component('trafficSourcesAutocompleteWrapper', react2angular(TrafficSourcesAutocompleteWrapper, ['trafficSourcesStorage', 'setTrafficSourcesStorage']))
.controller('MainCtrl', ['$scope', '$localStorage', 'AppHelper', 'ngDialog', '$filter', '$uibModal', 'apt', '$q', '$rootScope', function ($scope, $localStorage, AppHelper, ngDialog, $filter, $uibModal, apt, $q, $rootScope) {
	$scope.pageType        = "clinkManager";
	$scope.searchCallout   = "Search by Brand, Product name/ID or cLink ID";
	
	$scope.byApp = false;
	
	$scope.user = null;

	// Use clink manager specific local storage object to avoid issues with the campaign lookup page.
	if ( !$localStorage.clinkManager ) {
		$localStorage.clinkManager = {};
	}
	$scope.$storage = $localStorage.clinkManager;

    $scope.appPageSize = 50;			
	$scope.message = {};
	$scope.clinks = {};
	$scope.tabs = [];
	$scope.clinkCounts = {};
	
	$scope.availableCategories = [];
	$scope.clinkAssignableUsers = [];
	
	$scope.init = function() {
		//$scope.sortClinksBy('WeekClicks')
		//$scope.sortAppsBy('Clicks')
		$scope.currentUser = $scope.$ctrl.currentUser;

		// Listen for demand sources loaded event from React
		window.addEventListener('demandSourcesLoaded', function() {
			// Trigger digest cycle to update demand source labels
			$scope.$apply();
		});

		if ( pubID != null && siteID != null ) {
			$scope.user = pubID + ":" + siteID;
		}

		if ( $scope.isAdminUser() ) {
			$scope.clinkStatusMetadata = {
				AVAILABLE :  { buttonType : "success",  iconType : "fast-forward",  title : "Advance cLink" },	
				REQUESTED :  { buttonType : "success",  iconType : "forward",       title : "Approve Request" },	
				ACTIVE    :  { buttonType : "warning",  iconType : "pause",         title : "Pause or End cLink" },	
				PAUSED    :  { buttonType : "success",  iconType : "play",          title : "Re-Activate cLink" },	
				REJECTED  :  { buttonType : "success",  iconType : "backward",      title : "Revert Unapproved cLink" },
				ENDED     :  null
			};
		}
		else {
			$scope.clinkStatusMetadata = {
				AVAILABLE :  { buttonType : "success",  text : "Request",       title : "Request Campaign Approval" },	
				REQUESTED :  { buttonType : "warning",  text : "Cancel",        title : "Cancel Campaign Approval Request" },	
			};
		}
		
		
		if( !$scope.$storage.filters ) {
			$scope.$storage.filters = {
				publisher:'All'
			};
		}

		$scope.getPubNames();
		if ( $scope.canEditClinkField( 'ALL_FIELDS' ) ) {
			$scope.getAssignableClinkUsers();
		}
		
		var selectedTab = $scope.getSelectedTab();
		if ( !selectedTab ) {
			selectedTab = $scope.isAdminUser() ? "active" : ( $scope.allowAvailable() ? "available-all" : "recently_approved" );
		}
		
		if ( $scope.isAdminUser() ) {
			$scope.tabs.push( { type : "active",            name : "Active",                status : true, show_counts : true } );
			$scope.tabs.push( { type : "running",           name : "Live Today",            filter : true, show_counts : true } );
			// $scope.tabs.push( { type : "requested",         name : "Requested",             filter : true, show_counts : true } );
			$scope.tabs.push( { type : "recently_approved", name : "Recently Approved",     filter : true, show_counts : true } );
			$scope.tabs.push( { type : "paused",            name : "Paused",                status : true, show_counts : true } );
			$scope.tabs.push( { type : "unhealthy",         name : "Unhealthy",             filter : true, show_counts : true } );
			// $scope.tabs.push( { type : "needs_cleanup",     name : "Needs Cleanup",         filter : true, show_counts : true } );
			$scope.tabs.push( { type : "ended",             name : "Ended",                 status : true, show_counts : true } );
			// $scope.tabs.push( { type : "rejected",          name : "Unapproved",            status : true, show_counts : true } );
			// $scope.tabs.push( { type : "available-all",     name : "Available for Partner", filter : true, show_counts : false } );
		} else {
			// if ( $scope.allowAvailable() ) {
			// 	$scope.tabs.push( { type : "available-all",     name : "Available",         filter : true, show_counts : true } );
			// 	// $scope.tabs.push( { type : "requested",         name : "Requested",          filter : true, show_counts : true } );
			// } else if ( $scope.isViewAs() ) { // admin user viewing a partner, show the available tab the partner can't see
			// 	$scope.tabs.push( { type : "available-all",     name : "Available (Disabled for Partner)", filter : true, show_counts : false } );
			// }
			$scope.tabs.push( { type : "recently_approved", name : "Recently Approved",  filter : true, show_counts : true } );
			$scope.tabs.push( { type : "running",           name : "Live Today",         filter : true, show_counts : true } );
			$scope.tabs.push( { type : "active",            name : "Active",             status : true, show_counts : true } );
			$scope.tabs.push( { type : "paused",            name : "Paused",             status : true, show_counts : true } );
			$scope.tabs.push( { type : "ended",             name : "Ended",              status : true, show_counts : true } );
			// if ( $scope.allowAvailable() ) {
			//	 $scope.tabs.push( { type : "rejected",          name : "Unapproved",         status : true } );
			// }
		}
		
		var tabToFetch = null;

		for ( var i = 0; i < $scope.tabs.length; i++ ) {
		    $scope.tabs[i].maxApps = $scope.appPageSize;
		    $scope.tabs[i].loading = false;
	    	$scope.tabs[i].selected = ( selectedTab === $scope.tabs[i].type );
		    $scope.clinks[ $scope.tabs[i].type ] = null;
		    
			if ( $scope.tabs[i].selected ) {
				tabToFetch = $scope.tabs[i];
			}
		}
		
		if ( !tabToFetch ) {
			// If no tab is selected then default to the "active" for admin and "available-all" for partners that have this tab and "recently_approved" for those partners that don't.
			for ( let i = 0; i < $scope.tabs.length; i++ ) {
				if ( $scope.isAdminUser() ) {
					if ( $scope.tabs[i].type === "active" ) {
						$scope.tabs[i].selected = true;
						tabToFetch = $scope.tabs[i];
					}
				}
				else {
					 if ( $scope.allowAvailable() ) {
						 if ( $scope.tabs[i].type === "available-all" ) {
							$scope.tabs[i].selected = true;
							tabToFetch = $scope.tabs[i];
						 }					
					 }
					 else {
						 if ( $scope.tabs[i].type === "recently_approved" ) {
							$scope.tabs[i].selected = true;
							tabToFetch = $scope.tabs[i];
						 }					
					 }
				}
			}			
		}
		
		$scope.showTrafficSources = true;
		$scope.isMultipeTrafficSources = function () {
			if ($scope.$storage.filters.traffcSources && $scope.$storage.filters.traffcSources.length > 1) {
				return true;
			}
			return false;
		}

		if ( tabToFetch ) {
			$scope.saveSelectedTab( tabToFetch );
			if (tabToFetch.type !== "available-all" || !$scope.isMultipeTrafficSources()) {
				$scope.fetchClinks( tabToFetch ).then( function() {
					// TODO: Without this line the model doesn't update, but $apply() causes error
					console.info( "Tab Selected: " + tabToFetch.type ); 
				} );
			}
		}
	};
	
	$scope.getSelectedTab = function() {
		return AppHelper.getCookie( "selected_clink_tab" );
	};
	
	$scope.saveSelectedTab = function( tab ) {
		AppHelper.setCookie( "selected_clink_tab", tab.type );
	};
	
	/**
	 * Code to determine if the page being shown is for a reach partner user or for the admin user.
	 */
	$scope.isAdminUser = function() {
		var adminUser = window.permissions.indexOf('apptap:data:full-access') >= 0;
		return adminUser;
	};

	$scope.isAllowedCampaigns = function() {
		return window.permissions.indexOf('apptap:data:campaigns') >= 0;
	};

	$scope.isAllowedRTBData = function() {
		var allowed = ( window.permissions.indexOf('apptap:data:full-access') >= 0 ) || ( window.permissions.indexOf('apptap:data:rtb') >= 0 )
		return allowed;
	}

	$scope.isAllowedGrossRevenueData = function() {
		var allowed = ( window.permissions.indexOf('apptap:data:full-access') >= 0 ) || ( window.permissions.indexOf('apptap:data:gross-revenue') >= 0 )
		return allowed;
	}

	$scope.canEditCLink = canEditCLink;
	$scope.canEditClinkField = canEditClinkField;
	
	$scope.isViewAs = function() {
		if ( typeof viewAs !== 'undefined' ) {
			return viewAs;
		}
		return false;
	};
	
	$scope.allowAvailable = function() {
		if ( typeof allowAvailable !== 'undefined' ) {
			return allowAvailable;
		}
		return false;
	};
	
	$scope.selectTab = function( tab ) {
		// Load the data for this tab if it isn't loaded already and its not currently in the loading process
		if ( !$scope.clinks[ tab.type ] && !tab.loading ) {
			if (tab.type !== "available-all" || !$scope.isMultipeTrafficSources()) {
				$scope.fetchClinks( tab ).then( function() {
					console.info( "Tab Selected: " + tab.type );  // TODO: Without this line the model doesn't update, but $apply() causes error
				} );
			}
		}
		
		for ( var i = 0; i < $scope.tabs.length; i++ ) {
			if ( $scope.tabs[i].selected ) {
				if ( $scope.tabs[i].type !== tab.type) {
					$scope.tabs[i].selected = false;
					console.info( "Tab Unselected: " + $scope.tabs[i].type );  // TODO: Without this line the model doesn't update, but $apply() causes error
				}
			}
			else if ( $scope.tabs[i].type === tab.type ) {
				$scope.tabs[i].selected = true;
				console.info( "Tab Selected: " + $scope.tabs[i].type );   // TODO: Without this line the model doesn't update.
			}
		}
		
		$scope.saveSelectedTab( tab );
	};	
	
	$scope.trimCampaignID = function( campaignID ) {
		if ( campaignID ) {
			var parts = campaignID.split( "|" );
			return parts[0];
		}
		return campaignID;
	};
	
	$scope.generateCampaignData = function( clink ) {
		var data = "";
		for ( var i = 0; i < clink.campaigns.length; i++ ) {
			data = data + clink.campaigns[i].supplySource + ":" + $scope.trimCampaignID( clink.campaigns[i].campaignID ) + " @ $" + clink.campaigns[i].cpi;
			if ( i < clink.campaigns.length - 1 ) {
				data = data + ", ";
			} 
		}
		return data;
	};
	
	// reset all search parameters to their default values
	$scope.restore_defaults = function() {
		$scope.$storage.search_term  = '';
		
		$scope.$storage.showPlatformFilter   = false;
		$scope.$storage.showCountryFilter    = false;
		$scope.$storage.showPayoutFilter     = false;
		$scope.$storage.showCategoryFilter   = false;
		$scope.$storage.showIncentFilter     = false;
		$scope.$storage.showDeviceIDFilter   = false;
		$scope.$storage.showUniquenessFilter = false;
		$scope.$storage.showOwnerFilter      = false;
		$scope.$storage.showCounterBidFilter = false;
		$scope.$storage.showTagsFilter       = false;
		
		$scope.$storage.android      = true;
		$scope.$storage.iphone       = true;
		$scope.$storage.ipad         = true;
		
		$scope.$storage.countries    = '';
		$scope.$storage.minPayout    = '';
		// support_tags/notes
		// $scope.$storage.tags         = '';

		$scope.$storage.filters.publisher = "";
		$scope.$storage.filters.traffcSources = [];

		// workaround to refresh react2angular TrafficSourcesAutocompleteWrapper
		$scope.showTrafficSources = false;
		setTimeout(() => {
			$scope.showTrafficSources = true;
			$scope.$apply();
		}, 0);
	};

	$scope.setTagsStorage = function(tags) {
		$scope.$storage.tags = tags;
	};

	$scope.setTrafficSourcesStorage = function(traffcSources) {
		if (traffcSources && traffcSources.length) {
			$scope.$storage.filters.publisher = traffcSources[0].id;
			$scope.$storage.filters.traffcSources = traffcSources;

		} else {
			$scope.$storage.filters.publisher = "";
			$scope.$storage.filters.traffcSources = [];
		}
		$scope.applyCurrentFilter();
		$scope.$apply();
	};

	$scope.buildSearchParameters = function() {
		var params = {};

		if ( $scope.$storage.search_term ) {
			params['search'] = $scope.$storage.search_term;
		}
		
		if ( $scope.$storage.showCountryFilter ) {
			if ( $scope.$storage.countries ) {
				params['countries'] = $scope.$storage.countries;
			}
		}	
		
		if ( $scope.$storage.showCategoryFilter ) {
			if ( $scope.$storage.categories && $scope.$storage.categories.length > 0 ) {
				var categories = [];
				for ( var i = 0; i < $scope.$storage.categories.length; i++ ) {
					categories.push( $scope.$storage.categories[i].name );
				}			
				params['categories'] = categories.join( "," );
			}
		}
		
	    var platforms = null;
	    if ( $scope.$storage.showPlatformFilter ) {
	    	platforms = [];
		    if ( $scope.$storage.android ) platforms.push( 'android' );
		    if ( $scope.$storage.iphone )  platforms.push( 'iphone' );
		    if ( $scope.$storage.ipad )    platforms.push( 'ipad' );
		    
		    if ( platforms.length > 0 && platforms.length < 3 ) { 
		    	params['platforms'] = platforms.join(",");
		    }
		    // else .. no platforms selected or all platforms selected, either way then really nothing to filter on.
	    }	
		
	    if ( $scope.$storage.showPayoutFilter ) {
	    	params['minPayout'] = $scope.$storage.minPayout;
	    }
	    
	    var minSources = null;
	    var maxSources = null;
	    if ( $scope.$storage.showUniquenessFilter ) {
		   if ( $scope.$storage.useMinSources ) {
			   minSources = $scope.$storage.minDemandSources;
		   }
		   if ( $scope.$storage.useMaxSources ) {
			   maxSources = $scope.$storage.maxDemandSources;
		   }

		   params['minDemandSources'] = minSources;
		   params['maxDemandSources'] = maxSources;   
	    }
	    
	    var includeIncent    = true;
	    var includeNonincent = true;
	    
	    if ( $scope.$storage.showIncentFilter ) {
			includeIncent     = true === $scope.$storage.showIncent;
			includeNonincent  = true === $scope.$storage.showNonincent;

			params['includeIncent'   ] = includeIncent;
			params['includeNonincent'] = includeNonincent;
	    }	    
	    
	    var includeDIDRequired = true;
	    var includeDIDOptional = true;
	    if ( $scope.$storage.showDeviceIDFilter ) {
	    	includeDIDRequired = true === $scope.$storage.includeDeviceIDRequired;
	    	includeDIDOptional = true === $scope.$storage.includeDeviceIDOptional;

			params['includeDIDRequired'] = includeDIDRequired;
			params['includeDIDOptional'] = includeDIDOptional;	
	    }		
		
	    var includeSourceAppIDRequired = true;
	    var includeSourceAppIDOptional = true;
	    if ( $scope.$storage.showSourceAppIDFilter ) {
	    	includeSourceAppIDRequired = true === $scope.$storage.includeSourceAppIDRequired;
	    	includeSourceAppIDOptional = true === $scope.$storage.includeSourceAppIDOptional;

			params['includeSourceAppIDRequired'] = includeSourceAppIDRequired;	
			params['includeSourceAppIDOptional'] = includeSourceAppIDOptional;
	    }
	    
	    var includeSourceAppNameRequired = true;
	    var includeSourceAppNameOptional = true;
	    if ( $scope.$storage.showSourceAppNameFilter ) {
	    	includeSourceAppNameRequired = true === $scope.$storage.includeSourceAppNameRequired;
	    	includeSourceAppNameOptional = true === $scope.$storage.includeSourceAppNameOptional;

			params['includeSourceAppNameRequired'] = includeSourceAppNameRequired;	
			params['includeSourceAppNameOptional'] = includeSourceAppNameOptional;
	    }

		var includeDemandSources = null;
		if ( $scope.$storage.showSourceFilter ) {
			includeDemandSources = (_.difference(($scope.$storage.demandSources || []), ($scope.$storage.ignoredDemandSources || [])) || []).join(",");
			if (includeDemandSources) {
				params['allowDemandSources'] = includeDemandSources;
			}
			params['manualCampaignsOnly'] = true === $scope.$storage.manualCampaignsOnly;
		}

		var owner = null;
		if ( $scope.$storage.showOwnerFilter ) {
			owner = $scope.$storage.owner;
			params['owner'] = owner;
		}
		if ( $scope.$storage.showTagsFilter ) {
			params['tags'] = $scope.$storage.tags;
		}

		var counterBidSettings = null;
		if ( $scope.$storage.showCounterBidFilter ) {
	    	counterBidSettings = [];
		    if ( $scope.$storage.counterBidDefault ) counterBidSettings.push( 'default' );
		    if ( $scope.$storage.counterBidAllow   ) counterBidSettings.push( 'allow' );
		    if ( $scope.$storage.counterBidDisable ) counterBidSettings.push( 'disable' );
		    
		    if ( counterBidSettings.length > 0 && counterBidSettings.length < 3 ) { 
		    	params['counterBidSetting'] = counterBidSettings.join(",");
		    }
		    // else .. no counter bid settings selected or all counter bid settings selected, either way then really nothing to filter on.
		}
		params['includeCampaigns'] = false;

		return params;
	};
	
	$scope.addAdditionalParametersForFetchClinks = function( tab, params, loadingTab, includeClinkCounts ) {
		if ( tab.status ) {
			params['status'] = tab.type.split( '+' );
		}
		else if ( tab.filter ) {
			params['filter'] = tab.type;
		}

		if ( $scope.$storage.filters.traffcSources && $scope.$storage.filters.traffcSources && $scope.$storage.filters.traffcSources.length ) {
			let traffcSources = "";
			$scope.$storage.filters.traffcSources.forEach(trafficSource => {
				if (traffcSources !== "") traffcSources += ",";
				traffcSources += trafficSource.id;
			})
			params['placementsInclude'] = traffcSources;
		}

		if ( loadingTab ) {
			if ( tab.type === "available-all" && $scope.isAdminUser() && $scope.$storage.filters.publisher === "All"  ) {
				$scope.message[ tab.type ] = "Please select a publisher to see their available campaigns.";
				$scope.clinks[ tab.type ] = [];
				return false;  // Stop fetching.
			}
		}

		if ( $scope.$storage.availableMaxDemandSources ) {
			params['maxDemandSources'] = parseInt( $scope.$storage.availableMaxDemandSources );
		}
		
		if ( ( $scope.isAdminUser() || $scope.isViewAs() ) && $scope.user ) {
			params['user'] = $scope.user;
		}

		if ( includeClinkCounts ) {
			params['includeClinkCounts'] = 'true';
		}
		
		return true;  // Continue fetching
	};

	$scope.fetchAppData = function (clink) {
		const deferred = $q.defer();
		const results = {}

		if (!clink.configs[0] || !clink.configs[0].campaigns[0] || !clink.configs[0].campaigns[0].campaign_id) {
			$scope.loading = false;
			deferred.resolve(results['returned_app']);
			return deferred.promise;
		}

		const detailsSearch = {
			formattedOptimizations: true,
			returnCampaigns: true,
			returnStats: true,
			useExpandedSearchQuery: true,
			includeNotInFeed: true,
			clinkID: clink.clink_id
		};

		AppHelper.campaigns(detailsSearch,
			function (resp) {
				_.each(resp.apps, function (app) {
					if (app.appID === clink.app.appID) {
						clink.campaigns = app.campaigns;
					}
				});
				deferred.resolve(clink)
			},
			function () {
				deferred.reject();
				$scope.message = 'Could not query campaigns';
				ngDialog.open({
					template: 'static/dialogs/error.html',
					scope: $scope
				});
			},
			function () {
				$scope.loading = false;
				deferred.resolve(results['returned_app']);
			}
		);

		return deferred.promise;
	};

	$scope.fetchClinks = function( tab ) {
		tab.loading = true;

		var deferred = $q.defer();
		
		var params = $scope.buildSearchParameters();

		var continueFetching = $scope.addAdditionalParametersForFetchClinks( tab, params, true, true );
		if ( !continueFetching ) {
			// Need to return a "deferred promise" object for the caller, so resolve the deferred in the event.
			tab.loading = false;
			window.setTimeout( function() {
				deferred.resolve();
			}, 0 );
			return deferred.promise;
		}
		
		var cdn = 'https://s{INDEX}.api.apptap.com/img/';
		
		AppHelper.getClinks( params,
			function( data ) {
			    // Process the returned array of clinks.  If we are in "byApp" mode, then group by apps.
				var appDataMap = data.apps;

				for ( var appIdx = 0; appIdx < appDataMap.length; appIdx++ ) {
					var app       = appDataMap[appIdx];
					var appClinks = app.clinks;

					if ( app.icon ) {
						app.icon = cdn.replace( '{INDEX}', ( appIdx % 4 ) + 1 ) + app.icon.substring( 7 ) + '?s=45&type=icon';
					}

					for ( var i = 0; i < appClinks.length; i++ ) {
						appClinks[i].status      = appClinks[i].configs[0].status;
						appClinks[i].created     = $scope.getTime( appClinks[i].created );
						appClinks[i].last_update = $scope.getTime( appClinks[i].last_update );
						if ( appClinks[i].end_date ) {
							$scope.getTime( appClinks[i].end_date );
						}
						
						// // For requested clinks, their campaigns are returned during expansion to get the current matching campaigns.
						// if ( appClinks[i].status == "REQUESTED" ) {
						// 	appClinks[i].campaignsFetched = false;
						// }
						if ( app.icon ) {
							appClinks[i].app_icon = app.icon;
						}
						appClinks[i].app = app;
					}
				}
				
				$scope.message[ tab.type ] = null;
				$scope.clinks[tab.type] = appDataMap;
				$scope.clinkCounts = data.clink_counts;
			},
			function() {
				deferred.reject();
				$scope.message[ tab.type ] = 'Server returned an error loading the requested cLinks.';

				var dialogScope = $scope.$new(true)
				dialogScope.message = $scope.message[tab.type]
		    	ngDialog.open({
		    	    template: 'static/dialogs/error.html',
		    	    scope: dialogScope
		    	});
			},
			function() {
				tab.loading = false;
				deferred.resolve();
			}
		);
		return deferred.promise;
	};
	
	$scope.requestCreative = function( clink ) {
		var deferred = $q.defer();
		var params = {
	        clinkid : clink.clink_id
		};
		
		if ( $scope.isAdminUser() ) {
			params['user'] = $scope.user;
		} 
		
		// If we are in the middle of calling the server for this request type then ignore the click.
		if ( $scope.creativeRequestInProcess ) {
			return;
		}
		
		$scope.creativeRequestInProcess = true;
		
		AppHelper.requestCampaignCreative( params,
			function( data ) {
				var dialogScope = $scope.$new(true)
				dialogScope.message = 'Request for campaign creative has been sent.'
		    	ngDialog.open({
		    	    template: 'static/dialogs/success.html',
		    	    scope: dialogScope
		    	});
			},		
			function() {
				deferred.reject();
				var dialogScope = $scope.$new(true)
				dialogScope.message = 'Error sending campaign creative request.'
		    	ngDialog.open({
		    	    template: 'static/dialogs/error.html',
		    	    scope: dialogScope
		    	});
			},
			function() {
				deferred.resolve();
				$scope.creativeRequestInProcess = false;
			}
		);
		
		return deferred.promise;
	};
	
	$scope.createAppStoreLink = function( appID, platforms ) {
		if ( platforms.indexOf( "android" ) >= 0 ) {
			return "https://play.google.com/store/apps/details?id=" + appID;
		}
		else if ( platforms.indexOf( "ip" ) >= 0 ) {
			return "https://itunes.apple.com/sg/app/id" + appID + "?mt=8";
		}
		return null;
	};

	$scope.getTime = function( date ) {
		return new Date( date ).getTime();
	};

	$scope.getAssignableClinkUsers = function() {
        var deferred = $q.defer();

		AppHelper.getClinkAssignableUsers( {},
			function( data ) {
			    $scope.clinkAssignableUsers = data['users'];
			},
			function() {
			  deferred.reject();
			  $scope.message = 'Could not get users for Clink ownership';
			  ngDialog.open( {
				  template: 'static/dialogs/error.html',
				  scope: $scope
				} );
			  },
			  function() {
			    deferred.resolve();
			  }
		);
  
        return deferred.promise;
	}

	$scope.getPubNames = function() {
		var deferred = $q.defer();
		$scope.loadingPublishers = true;
		AppHelper.getPublishers( {'clinkable':true},
			function( data ) {
				var formatted = [{'name':'-All-','id':'All'}];
				_.forEach( _.keys( data ), function(key) {
					formatted.push({
						'name':data[key],
						'id':key
					});
				});

				// Create the data structure for the main publishers filter.
				$scope.$storage.publisherNames = formatted;
				$scope.$storage.publishers = data;
			},
			function() {
				deferred.reject();
				var dialogScope = $scope.$new(true)
				dialogScope.message = 'Error getting publisher name';
				ngDialog.open({
					template: 'static/dialogs/error.html',
					scope: dialogScope
				});
			},
			function() {
				$scope.loadingPublishers = false;
				deferred.resolve();
			}
		);
		return deferred.promise;
	};

	$scope.getClinksCsv = function() {
		var ret = [];
		var header = document.querySelector('.header-row');
		var rows   = document.querySelectorAll('.data-row');

		ret.push( $scope.getRowCsv( header ) );
		for( var i=0; i<rows.length; i++ ) {
			ret.push( $scope.getRowCsv( rows[i] ) );
		}

		return ret;
	};

	$scope.getRowCsv = function( elem ) {
		var items = [];
		for( var i=0; i<elem.children.length; i++ ) {
			var data = elem.children[i].getAttribute('data-csv');
			if( data !== 'ignore' ) {
				items.push( data );
			}
		}
		return items;
	};

	$scope.updateStatus = function ( clink, app ) {
	    var pauseClink = $uibModal.open({
	      templateUrl: 'views/pause/pause_clink.html',
	      controller: 'PauseClinkCtrl',
	      windowClass: 'status-update-dialog',
	      resolve : {
	    	  clink_id: function() {
	    		  return clink.clink_id;
	    	  },
	    	  status: function() {
	    		  return clink.status;
	    	  },
	    	  title: function() {
	    		  return $scope.clinkStatusMetadata[clink.status].title;  
	    	  },
	    	  app_name: function() {
	    		  return app.title;  
	    	  },
	    	  platforms: function() {
	    		  return clink.configs[0].platforms;
	    	  },
	    	  countries: function() {
	    		  return clink.configs[0].countries;
	    	  },
	    	  payout: function() {
	    		  return clink.configs[0].p2p;
	    	  },
	    	  user: function() {
	    		  return $scope.user;
	    	  }
	      }
	    });
	    
	    pauseClink.result.then( function( choice ) {
	    	$scope.changeClinkStatus( clink, app, choice );
	    });
	};
	
	$scope.changeClinkStatus = function( clink, app, choice ) {
    	var deferred = $q.defer();
    	
		if ( choice === "REQUESTED" ) {
			var params = { 
				'appid' : clink.app_id, 
				'platforms' : clink.configs[0].platforms, 
				'countries' : clink.configs[0].countries, 
	            'p2p' : clink.configs[0].p2p, 
	            'allowIncent' : clink.incent 
	        };
			
			if ( ( $scope.isAdminUser() || $scope.isViewAs() ) && $scope.user ) {
				params['user'] = $scope.user;
			}
			
			// If the reach partner is making a request for approval, then use that specific API (which is really a specialized clink create).
			AppHelper.requestClink( params,
				function( data ) {
					var dialogScope = $scope.$new(true)
					dialogScope.message = 'An approval request for the "' + app.title + '" campaign has been submitted.';
			    	ngDialog.open({
			    	    template: 'static/dialogs/success.html',
			    	    scope: dialogScope
			    	});
			    	
			    	// Set the newly created clink's ID into this placeholder clink in case user wants to cancel their request.
			    	clink.requested_clink_id = data.clinkid;
			    	
			    	$scope.updateClinkStatus( clink, choice );
				},
				function() {
					deferred.reject();
					var dialogScope = $scope.$new(true)
					dialogScope.message = 'An approval request for the "' + app.title + '" campaign has been submitted.';
			    	ngDialog.open({
			    	    template: 'static/dialogs/error.html',
			    	    scope: dialogScope
			    	});
				},
				function() {
					deferred.resolve();
				}
			);
		}
		else if ( choice === "ASSIGN_ACTIVATE" ) {
			// If the choice is to "Assign and Activate" from a requested clink, then we need to open the clink editor popup to assign a campaign and
			// then make it active.
			$scope.openClinkToEdit( choice, clink, app );
			
			/* These campaigns are now coming back as part of the cLink, but we may need this in future if optimizations are put in to place. 
			// First we need to ensure the campaigns are loaded for this requested clink.
			if ( !clink.campaigns || !clink.campaigns[0] ) {
			    // First time expansion for this clink, fetch the matching campaigns.
				$scope.fetchMatchingCampaignsForRequestedClink( clink ).then( function() {
					$scope.openClinkToEdit( choice, clink, app );
				} );
			}
			else {
				$scope.openClinkToEdit( choice, clink, app );
			}
			*/
		}
		else {
			// For all other choices update the status of the current cLink.
			
	    	// If the reach partner is canceling a request, then change the requested clink to "non-approved" to keep record of original request 
			// and change the campaign back to available. 
			var clinkID = clink.clink_id;
			var updateToChoice = choice;
			if ( choice === "AVAILABLE" ) {
				if ( clink.requested_clink_id) {
					clinkID = clink.requested_clink_id;
				}
			    updateToChoice = "REJECTED";
			}
			
	    	AppHelper.changeClinkStatus( { 'clinkid':clinkID, 'status':updateToChoice }, 
				function( data ) {
					var dialogScope = $scope.$new(true)

					if ( choice === "AVAILABLE" ) {
	    				dialogScope.message = 'The request for approval of the "' + app.title + '" campaign has been cancelled.';
	    			}
	    			else {
	    				dialogScope.message = 'cLink status set to: ' + choice;
	    			}
	    			
			    	ngDialog.open({
			    	    template: 'static/dialogs/success.html',
			    	    scope: dialogScope
			    	});
			    	$scope.updateClinkStatus( clink, choice );
				},
				function() {
					deferred.reject();

					var dialogScope = $scope.$new(true)
					dialogScope.message = 'Error updating clink status';

			    	ngDialog.open({
			    	    template: 'static/dialogs/error.html',
			    	    scope: dialogScope
			    	});
				},
				function() {
					deferred.resolve();
				}
			);
		}
		
		return deferred.promise;
	};
	
	$scope.getFilteredCLinksCount = function( clinksToFilter, tabType ) {
		if ( tabType === 'requested' ) {
			var count = 0;
			for ( var i = 0; i < clinksToFilter.length; i++ ) {
				if ( clinksToFilter[i].configs[0].status === "REQUESTED" ) {
					count++;
				}
			}
			return count;
		}
		
		return clinksToFilter.length;
	};
	
	$scope.openClinkToEdit = function( choice, clink, app ) {
	    // For "Requested" clinks, this is the list of "other" non-requested clinks related to this app.
	    var otherClinks = [];
	    if ( choice === 'ASSIGN_ACTIVATE' ) {
		  for ( var i = 0; i < app.clinks.length; i++ ) {
			  if ( app.clinks[i].configs[0].status !== "REQUESTED" ) {
				  otherClinks.push( app.clinks[i] );
			  }
		  }
  	    }
	  
	    var editClink = $uibModal.open( {
	        templateUrl: './clink_modification/views/create/create.html',
	        controller: 'CreateClinkCtrl',
	        size: 'clink-mod',  // Adds class to modal-dialog element called "modal-click-mod"
			animation: false,
	        resolve : {
	      	  appID: function() {
	      		  return clink.app_id;
	      	  },
	      	  appTitle: function() {
	      		  return app.title;
	      	  },
	      	  appIcon: function() {
	      		  return app.icon;  
	      	  },
	      	  campaigns: function() {
	      		  return clink.campaigns;
	      	  },
	      	  allCampaigns: function() {
	      		  return clink.campaigns;
	      	  },
	      	  clinks: function() {
	      		  return otherClinks;
	      	  },
	      	  existingClink: function() {
	      		  return clink;
	      	  }
	        }
	      });

	    editClink.result.then( function( clinkid ) {
			var dialogScope = $scope.$new(true)
			dialogScope.message = 'Edited cLinks'
			dialogScope.clinkids = [ clinkid ]
	    	ngDialog.open({
	    	    template: 'static/dialogs/createdClink.html',
	    	    scope: dialogScope
		    });
	    	$scope.updateClinkStatus( clink, "ACTIVE" );
	    });

	};
	
	$scope.updateClinkStatus = function( clink, newStatus ) {
    	clink.status = newStatus;
    	
    	if ( newStatus === "AVAILABLE" || newStatus === "REQUESTED" ) {
        	// If the clink is for the "AVAILABLE" or "REQUESTED" state, then invalite the data for the tab the user is currently not on
    		// since a request causes a new clink to be created or the new clink doesn't know about the availble campaign "faux" clink.
    		var selectedTabType = $scope.getSelectedTab();    		
    		if ( selectedTabType !== "available-all" ) {
        		$scope.clinks[ "available-all" ] = null;
    		}
    		if ( selectedTabType !== "requested" ) {
        		$scope.clinks[ "requested" ] = null;
    		}
    	}
    	else {
	    	// Look for this cLink on any other tab.
	    	for ( var type in $scope.clinks ) {
	    	    if ( $scope.clinks.hasOwnProperty( type ) && $scope.clinks[type] ) {
	    	    	var clinks =  $scope.clinks[type];
	    	    	for ( var i = 0; i < clinks.length; i++ ) {
	    	    		if ( $scope.byApp ) {
	    	    			var app = clinks[i];
	    	    			for ( var j = 0; j < app.clinks.length; j++ ) {
	    	    				if ( app.clinks[j].clink_id === clink.clink_id ) {
	    	    					app.clinks[j].status = newStatus;
	    	    				}
	    	    			}
	    	    		}
	    	    		else {
		    	    		if ( clinks[i].clink_id === clink.clink_id ) {
		    	    			clinks[i].status = newStatus;
		    	    		}
	    	    		}
	    	    	}
	    	    }
	    	}
    	}
	};
	
	$scope.exportCurrentTabToCSV = function() {
		// Determine the currently selected tab.
		const selectedTab = $scope.getSelectedTab();

		// Fetch the clinks and export to CSV.
		if ( selectedTab ) {
			var params = $scope.buildSearchParameters();
			$scope.addAdditionalParametersForFetchClinks( selectedTab, params, false, false );
			params['export'] = 'csv';
			// conflict with react router
			// window.location = AppHelper.join_paths(window.proxy, '/admin/clinks?method=getClinks&' + jQuery.param( params ));
			window.open(process.env.REACT_APP_JUPITER_API_BASE_URL + '/admin/clinks?method=getClinks&' + jQuery.param( params ));
		}
	};

	$scope.search = function() {
		$scope.search_filter = $scope.$storage.search_term;
		$scope.applyCurrentFilter();
	};

	$scope.keyPress = function( event ) {
		if( event.keyCode === 13 ) {
			$scope.search();
		}
	};

	$scope.getClassNameForClinkID = function( clink_id ) {		
		return clink_id.split('.').join('_');
	};

	/* Now associated campaigns are coming along with the original clink call, however we may need to fetch in the future for optimization.
	$scope.fetchMatchingCampaignsForRequestedClink = function( clink ) {
		var deferred = $q.defer();
		
		var params = {
				requestedClinkID :  clink.clink_id,
				returnCampaigns :  true,
				returnStats :      true
		};
		
		AppHelper.campaigns( params,
		   	function( data ) {
			    // There should only be 1 app returned.  If none, then no matching campaigns.
			    if ( data.apps[0] ) {
					clink.campaigns = data.apps[0].campaigns;
			    }
				clink.campaignsFetched = true;
			},
		    function() {
		    	deferred.reject();
		    	$scope.message = 'Could not query campaigns';
		    	ngDialog.open({
		    	    template: 'static/dialogs/error.html',
		    	    scope: $scope
		    	});
		    },
		    function() {
			    deferred.resolve();
			    $scope.$apply();
		    }
		);
		
		return deferred.promise;
	};
	*/
	
	$scope.getHealthClass = function( health ) {
		return health.toLowerCase();
	};

	$scope.getNumClinks = function() {
		return document.querySelectorAll('.data-row').length;
	};

	$scope.getSelectedTab = function() {
		var selectedTab = null;
		for ( var i = 0; i < $scope.tabs.length; i++ ) {
			if ( $scope.tabs[i].selected ) {
				selectedTab = $scope.tabs[i];
				break;
			}
		}
		return selectedTab;
	};
	
	$scope.applyCurrentFilter = function() {
		// Clear the loaded clinks and re-fetch for the current tab.  The other tabs will be reloaded upon demand.
		for ( var type in $scope.clinks ) {
		    if ( $scope.clinks.hasOwnProperty( type ) ) {
		    	 $scope.clinks[type] = null;		
		    }
		}

		for ( let i = 0; i < $scope.tabs.length; i++ ) {
		    $scope.tabs[i].maxApps = $scope.appPageSize;
		}

		const selectedTab = $scope.getSelectedTab();
		if ( selectedTab ) {
			if (selectedTab.type !== "available-all" || !$scope.isMultipeTrafficSources()) {
				selectedTab.loading = true;
				$scope.fetchClinks( selectedTab ).then( function() {
					console.info( "Tab Selected: " + selectedTab.type );  // TODO: Without this line the model doesn't update, but $apply() causes error
				} );
			}
		}
	};

	$scope.showSummary = function() {
		(function() {
			var deferred = $q.defer();
			AppHelper.getAllClinksSummary( {},
				function( data ) {
					$uibModal.open({
				      templateUrl: 'clink_manager/views/main/summary.html',
				      controller: 'SummaryCtrl',
				      resolve : {
			    	  	summary: function() {
			    		  return data.summary;
			    	    }
				      }
				    });
				},
				function() {
					var dialogScope = $scope.$new(true)
					dialogScope.message = 'Error getitng cLink summary'
					ngDialog.open({
						template: 'static/dialogs/error.html',
						scope: dialogScope
					});
					deferred.reject();
				},
				function() {
					deferred.resolve();
				}
			);
			return deferred.promise;
		})();
	};

	$scope.getCampaignQuota = function( quota ) {
		if( !quota || isNaN( quota ) ) {
			return '-';
		}
		return '' + quota + '%';
	};

	$scope.getCampaignLimit = function( limit ) {
		if( !limit ) {
			return 'None';
		}
		return limit + '/day';
	};

	$scope.verify = function( clink_data ) {
	    $uibModal.open({
	      templateUrl: 'clink_manager/views/main/verify.html',
	      controller: 'VerifyCtrl',
	      resolve : {
    	  	clink: function() {
    		  return clink_data;
    	    }
	      }
	    });
	};
	
	$scope.clinkURLDecoder = function() {
	    $uibModal.open({
		    templateUrl: 'clink_manager/views/main/clink_url_decoder.html',
		    controller: 'CLinkURLDecoder'
		});
	};
	
	$scope.clinkIDDecoder = function() {
	    $uibModal.open({
		    templateUrl: 'clink_manager/views/main/clink_id_decoder.html',
		    controller: 'CLinkIDDecoder'
		});
	};
}]);